<template>
  <div
    class="title"
    :style="{
      backgroundImage: 'url(' + `${bgurl}` + ')',
      backgroundSize: `${bgSize}rem 0.41rem`,
    }"
  >
    <p class="en">{{ titleInfo.titleEn }}</p>
    <p class="cn" v-html="titleInfo.titleCn"></p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bgurl: require("@/images/com/page_title_bg.png")
    };
  },
  props: {
    titleInfo: {
      type: Object
    },
    bgSize: {
      type: Number
    },
    longBg: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    longBg: {
      immediate:true,
      handler(newV) {
        if(newV) {
          this.bgurl = require("@/images/com/page_title_bg2.png")
          this.bgSize = this.bgSize || 5.8
        }
      }
    }
  },
  methods: {
    getPath() {
      console.log(this.textInfo.path);
      this.$emit("backParams", 1);
    },
    clickFun() {
      console.log("组件内方法");
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  background-repeat: no-repeat;
  background-position: left bottom;
  background-size: 2.1rem 0.41rem;
  .en {
    font-size: 0.18rem;
    color: #ffb701;
    height: 0.18rem;
    line-height: 0.18rem;
  }
  .cn {
    height: 0.38rem;
    font-size: 0.38rem;
    color: #fff;
    line-height: 0.38rem;
    padding: 0.1rem 0 0.25rem;
    font-weight: 800;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/titleBox.vue